import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormField from './ReduxFormsField';

const validate = (values, props) => {
  let errors = {};
  if (!values.name || !values.name.trim()) {
    errors.name = [`You must enter the ${props.entityType.toLowerCase()} name`];
  } else if (values.name.trim() !== props.requiredConfirmationText) {
    errors.name = [`You must enter the ${props.entityType.toLowerCase()} name exactly as it is shown above to confirm`];
  }
  return errors;
};

class DeleteForm extends Component {
  static propTypes = {
    ...formPropTypes,
    requiredConfirmationText: PropTypes.string,
  };

  render() {
    const { entityType, handleSubmit, onCancel, onSubmit, requiredConfirmationText, submitting } = this.props;

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="modal__content">
          <h3>{`Delete ${entityType}`}</h3>
          <p>
            Deleting <em>{requiredConfirmationText}</em> will also delete all associated content.
          </p>
          <span>Are you sure you want to do this?</span>
          <Field
            name="name"
            component={ReduxFormField}
            label={`Enter the name of the ${entityType.toLowerCase()} to confirm:`}
            required={true}
          >
            <input type="text" />
          </Field>
        </div>
        <div className="modal__actions">
          <div className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
            Cancel
          </div>
          <button type="submit" className="button" disabled={submitting}>
            Submit
          </button>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'deleteForm',
  validate,
})(DeleteForm);



// WEBPACK FOOTER //
// ./src/common/forms/DeleteForm.js